module.exports = __webpack_public_path__ + "img/light-grey.7613ea61.png";